import { useState } from 'react'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'

import styles from 'styles/OfferEquipment.module.css'

const Equipment = ({ offer: { options }, showCount = 10 }) => {
    if (!options?.length) return null

    const [showAll, setShowAll] = useState(false)
    const allSeen = options.length <= showCount
    const allShowed = allSeen || showAll
    const viewableOptions = allShowed
        ? options
        : options.slice(0, showCount)

    return (
        <div>
            <aside className={styles.wrapper}>
                <h2 className={styles.h}>{useT('Wyposażenie')}:</h2>

                <div className={styles.opts}>
                    { viewableOptions.map(opt => <Option key={opt} opt={opt} />) }
                </div>

                {
                    !allShowed && <button className={styles.more} onClick={() => setShowAll(true)}><Icon>more_horiz</Icon></button>
                }
            </aside>
        </div>
    )
}

function Option ({ opt }) {
    return opt
        ? <span className={styles.opt}>{opt}</span>
        : null
}

export default Equipment